import React, { useEffect, useState } from "react";
import ApiClient from "utils/ApiClient";
import { FIELD_TYPES_BY_FIELD_TYPE } from "../lib/constants";
import { inject, observer } from "mobx-react";
import Progress from "../Progress";

const CreateDummyDataTaskAction = ({
  onRequestParams,
  onComplete,
  chatHelpersStore,
  onStepComplete = () => null,
  component,
}) => {
  const [progress, setProgress] = useState({label: "", sheetName: ""})

  const handleOnLoad = async () => {
    let params = await onRequestParams();
    let sheetIds = params[0].sheetIds;
    createDummyData(sheetIds);
  };

  const createDummyData = async (listIds = []) => {
    try {
      let sheetIdList = [];
      let lookupCols = [];
      let listConfigById = {};
      for (const sheetId of listIds) {
        sheetIdList.push(sheetId);
        let resp = await ApiClient.List.getListConfig({
          list_id: sheetId,
        });
        if (resp.success) {
          let cols = resp.data?.listData;
          listConfigById[sheetId] = resp.data;
          for (let col of cols) {
            let options = JSON.parse(col.options)[0];
            if (col.column_type_id == 10) {
              lookupCols.push({
                colId: col.id,
                sourceList: options.source_list_id,
                sourceColumn: options.source_column_id,
                currentList: sheetId,
              });
            }
            if (col.column_type_id == 6) {
              let configs = await ApiClient.List.getListConfig({
                list_id: options.sub_list_id,
              });
              for (let colConfig of configs.data?.listData) {
                if (colConfig.column_type_id == 10) {
                  let opts = JSON.parse(colConfig.options)[0];
                  lookupCols.push({
                    colId: colConfig.id,
                    sourceList: opts.source_list_id,
                    sourceColumn: opts.source_column_id,
                    parentList: sheetId,
                    parentColumn: col.id,
                    currentList: options.sub_list_id,
                  });
                }
              }
            }
          }
        }
      }
      for (let i = 0; i < sheetIdList.length; i++) {
        const id = sheetIdList[i];
        if(listConfigById[id].hasOwnProperty("listData") && listConfigById[id].listData.length <= 3) {
          continue;
        }
        await addDummyDataToSheetHelper(id, listConfigById[id]);
        onStepComplete({ sheetsCount: listIds.length - ( i + 1 ), log: `Added sample data into ${listConfigById[id].list.name} sheet` });
      }
      await addDummyDataToLookup(lookupCols);
    } catch (error) {
      console.log(error);
    } finally {
      onComplete();
    }
  };

  const addDummyDataToLookup = async (columns = []) => {
    for (let column of columns) {
      let data = [];
      let lookupColData = await ApiClient.List.getLookupColumnData({
        column_id: column.colId,
      });
      if (lookupColData.success) {
        lookupColData.data?.forEach((el) => {
          data.push(
            JSON.stringify({
              value: el["column_" + column.sourceColumn],
              reference_column_id: el["row_id"],
            })
          );
        });
      }
      let tempRowIds = [1, 2, 3, 4, 5];
      try {
        let views = await ApiClient.Views.getViews({
          list_id: column.parentList ? column.parentList : column.currentList,
        });
        let mainView = views.data?.filter((el) => el.is_main_view == 1);
        let mainViewId = "";
        if (mainView.length > 0) {
          mainViewId = mainView[0].id;
        }
        let rows = await ApiClient.Views.getViewData({
          list_id: column.parentList ? column.parentList : column.currentList,
          view_id: mainViewId,
        });
        if (rows.success) {
          tempRowIds = [];
          rows.data?.data?.forEach((el) => {
            tempRowIds.push(el.row_id);
          });
        }
      } catch (error) {
        console.log(error);
      }

      tempRowIds.forEach(async (i) => {
        if (column.hasOwnProperty("parentList")) {
          let rowData = await ApiClient.List.getRowData({
            row_id: i,
            list_id: column.parentList,
            column_id: column.parentColumn,
          });
          if (rowData.data["column_" + column.parentColumn]?.length > 0) {
            rowData.data["column_" + column.parentColumn]?.forEach((el) => {
              ApiClient.List.addEditCell({
                parent_list_id: column.parentList,
                parent_row_id: i,
                parent_column_id: column.parentColumn,
                column_id: column.colId,
                value: data[Math.floor(Math.random() * data.length)],
                list_id: column.currentList,
                row_id: el.row_id,
              });
            });
          } else {
            for (let j = 1; j <= 5; j++) {
              await ApiClient.List.addEditCell({
                parent_list_id: column.parentList,
                parent_row_id: i,
                parent_column_id: column.parentColumn,
                column_id: column.colId,
                value: {
                  [column.colId]: {
                    value: data[Math.floor(Math.random() * data.length)],
                    is_modified: true,
                    row_id: "",
                    column_type_id: 10,
                  },
                },
                list_id: column.currentList,
                row_id: "",
              });
            }
          }
        } else {
          ApiClient.List.addEditCell({
            row_id: i,
            column_id: column.colId,
            value: data[Math.floor(Math.random() * data.length)],
            list_id: column.currentList,
          });
        }
      });
    }
  };

  const addDummyDataToSheetHelper = async (sheetId, listConfig = {}) => {
    try {
      let { temprows, subsheetColumns } = await getFormattedDummyData(
        sheetId,
        listConfig
      );
      let rows = [];
      temprows.forEach(async (row) => {
        let savedRow = await ApiClient.List.saveRowForm({
          list_id: sheetId,
          data: row,
        });
        rows.push(savedRow?.row?.row_id);
      });
      for (let subCol of subsheetColumns) {
        let opts = JSON.parse(subCol.options)[0];
        let { temprows: subsheetTempRows } = await getFormattedDummyData(
          opts?.sub_list_id
        );
        rows.forEach(async (row) => {
          subsheetTempRows.forEach(async (subrow, index) => {
            await ApiClient.List.addEditCell({
              list_id: opts?.sub_list_id,
              parent_list_id: sheetId,
              parent_column_id: subCol.id,
              parent_row_id: row,
              value: JSON.stringify(subrow),
            });
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
    return;
  };

  const getFormattedDummyData = async (sheetId, listConfig = {}) => {
    try {
      if (!listConfig.hasOwnProperty("list")) {
        let response = await ApiClient.List.getListConfig({
          list_id: sheetId,
        });
        listConfig = response.data;
      }

      let columns = [];
      if (listConfig.hasOwnProperty("listData")) {
        columns = listConfig.listData;
      }
      let columnTypeIdByName = {};
      let subsheetColumns = [];
      for (let column of columns) {
        if (
          column.column_type_id != 10 &&
          column.column_type_id != 6 &&
          column.column_type_id != 7 &&
          column.column_type_id != 9 &&
          column.column_type_id != 19
        ) {
          if (
            column.name != "Created By" &&
            column.name != "Updated On" &&
            column.name != "Created On" &&
            column.name != "Star"
          ) {
            columnTypeIdByName[column.name] = {
              type: FIELD_TYPES_BY_FIELD_TYPE[column.column_type_id],
              type_id: column.column_type_id,
              id: column.id,
            };
          }
        }
        if (column.column_type_id == 6) {
          subsheetColumns.push(column);
        }
      }

      let colMap = {};

      for (let column of columns) {
        colMap[column.name] = { id: column.id, type: column.column_type_id };
        if (
          column.column_type_id == 3 ||
          column.column_type_id == 11 ||
          column.column_type_id == 13
        ) {
          let options = JSON.parse(column.options);
          options = options[0].options;
          columnTypeIdByName[column.name].enum = options;
        }
      }
      setProgress({...progress, label: `Adding sample data into ${listConfig.list?.name} ${listConfig.list?.parent_list_id === "0" ? "sheet" : "subsheet" }`, sheetName: listConfig.list?.name})
      let data = await getDummyData(columnTypeIdByName);
      let temprows = [];
      data.dummyData?.forEach((row) => {
        let obj = {};
        for (let key in row) {
          let value = row[key];
          try {
            if (colMap[key].type == 22) {
              value = parseInt(value);
              value = Number(value / 100).toFixed(2);
            }
          } catch (error) {
            value = Math.random().toFixed(2);
          }
          obj[colMap[key].id] = {
            value: value,
            column_type_id: colMap[key].type,
            is_modified: true,
            row_id: "",
          };
        }
        temprows.push(obj);
      });
      return { temprows, subsheetColumns };
    } catch (error) {
      console.log(error);
    }
  };

  const getDummyData = async (columnTypeIdByName) => {
    try {
      let properties = {};
      let requiredArray = [];
      let colContext = "";

      for (let columnName in columnTypeIdByName) {
        properties[columnName] = {
          type: "string",
          description: "random value for " + columnName,
        };
        if (
          columnTypeIdByName[columnName].type_id == 3 ||
          columnTypeIdByName[columnName].type_id == 11 ||
          columnTypeIdByName[columnName].type_id == 13
        ) {
          properties[columnName].enum = columnTypeIdByName[columnName].enum;
        }
        requiredArray.push(columnName);

        colContext +=
          columnName +
          "(type: " +
          (columnTypeIdByName[columnName].type == "currency"
            ? "number"
            : columnTypeIdByName[columnName].type) +
          "), \n";
      }

      let context = [
        {
          type: "internal",
          role: "system",
          content: `You are a helpful assistant. You will be given some columns and there types 
          You have to provide five random data rows with values for each of the columns.
          Note:-
            1. Try to provide some real data, like companies, products, vendors etc, all of these entites or values should be real instead of some jibberish.
            2. Try to provide mix up of Indian and English values.
            3. Try to use entity names whenever possible instead of individual names and try to keep name realistic instead of ABC or XYZ.
            4. Do not use lorem ipsum text
            5. Try to provide any date , month, year etc related values in this format only -> YYYY-MM-DD HH:MM:SS
          for example:-
          user:- 
          name(type: text)
          age(type: number)
          gender(type: dropdown)
          provide dummy data for the following columns which are present in users sheet
          
          assistant:- {values : [
            {name:"Anand Kumar", age:20, gender:"male"},
            {name:"Zoya Akhtar", age:21, gender:"female"},
            {name:"Kunal Sharma", age:22, gender:"male"},
            {name:"Siddharth Gautam", age:23, gender:"male"},
            {name:"Anupriya Chauhan", age:24, gender:"female"}
          ]}
        `,
        },
      ];
      let functions = [
        {
          name: "getDummyData",
          description: "returns random data for the columns provided by user",
          parameters: {
            type: "object",
            properties: {
              dummyData: {
                type: "array",
                description:
                  "an array of dummy rows of type object with column name as key and random data as value",
                items: {
                  type: "object",
                  description:
                    "for every column user provides there will a key for every column in this object and as a value you have to provide random data",
                  properties: properties,
                  required: requiredArray,
                },
              },
            },
          },
        },
      ];

      let msgs = context;
      msgs = [
        ...msgs,
        {
          role: "user",
          content:
            colContext +
            " \ngenerate dummy data for the following above columns",
          type: "message",
        },
      ];

      const body = {
        frequency_penalty: 0,
        max_tokens: 1024,
        model: "gpt-4",
        temperature: 1,
        top_p: 1,
        presence_penalty: 0,
        messages: msgs
          .filter(
            (message) =>
              message.type === "message" || message.type === "internal"
          )
          .map((message) => {
            if (message.role == "function") {
              return {
                role: message.role,
                content: message.content,
                name: message.name,
              };
            }
            return {
              role: message.role,
              content: message.content,
            };
          }),
        functions: functions,
        function_call: { name: "getDummyData" },
        stream: false,
      };

      const accessToken =
        await window.appStore.assistantStore.getChatsAccessToken();

      const res = await chatHelpersStore.getChatCompletion(
        window.appStore.chatSettingsStore.apiEndpoints.chatCompletionUrl,
        body,
        {
          headers: { Authorization: `Bearer ${accessToken?.token}` },
        }
      );

      return chatHelpersStore.parseOpenAIFnResponse(res.data)?.args || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const renderDummyDataTaskAction = () => {
    return (
      <Progress progress={progress} parentComponent={component}/>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderDummyDataTaskAction();
};

export default inject(({ store }) => {
  return {
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(CreateDummyDataTaskAction));
